import(/* webpackMode: "eager" */ "/app/apps/mondial.ch/src/app/(website)/[lang]/error.tsx");
